import { render, staticRenderFns } from "./qaStream.vue?vue&type=template&id=b01d880c&scoped=true&"
import script from "./qaStream.vue?vue&type=script&lang=js&"
export * from "./qaStream.vue?vue&type=script&lang=js&"
import style0 from "./qaStream.vue?vue&type=style&index=0&id=b01d880c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01d880c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b01d880c')) {
      api.createRecord('b01d880c', component.options)
    } else {
      api.reload('b01d880c', component.options)
    }
    module.hot.accept("./qaStream.vue?vue&type=template&id=b01d880c&scoped=true&", function () {
      api.rerender('b01d880c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/firstPage/qaStream.vue"
export default component.exports